import Highcharts from 'highcharts/highstock'
import HighchartsReact from 'highcharts-react-official'
import { useTranslation } from 'react-i18next'
import { useEffect } from 'react'
require('highcharts/indicators/indicators')(Highcharts)
require('highcharts/indicators/pivot-points')(Highcharts)
require('highcharts/indicators/macd')(Highcharts)

export default function HistoryPriceChart2({price, volume, label = {}}) {
    const {t, i18n} = useTranslation();

    var groupingUnits = [[
        'week', // unit name
        [1] // allowed multiples
    ], [
        'month',
        [1, 2, 3, 4, 6]
    ]];
    
    const stockOptions = {
        accessibility: {
            enabled: false
        },
        chart: {
            alignTicks: false,
            height: 550
        },
        rangeSelector: {
            selected: 5,
        },
        title: {
            text: label.title
        },
        tooltip: {
            xDateFormat: '%A, %b %d, %Y'
        },
        yAxis: [{
            title: {
                text: label.price
            },
            height: '75%',
            height: '70%',
            lineWidth: 2,
            opposite: false
        }, {
            title: {
                text: label.volume
            },
            top: '75%',
            height: '25%',
            offset: 0,
            lineWidth: 2,
            opposite: false
        }],
        series: [{
            data: price,
            type: 'candlestick',
            name: 'Price',
            color: '#4572a7',
            colors: '#4572a7',
            dataGrouping: {
                units: groupingUnits
            }
        }, {
            type: 'column',
            name: 'Volume',
            data: volume,
            yAxis: 1,
            color: '#aa4643',
            colors: '#aa4643',
            dataGrouping: {
                units: groupingUnits
            }
        }]
    }

    useEffect(() => {
        const chart = Highcharts.charts[Highcharts.charts.length - 1];
        if (chart){
            chart.zoomOut();
            chart.reflow();
        }
    }, [i18n.language, volume, price])


    return (
        <HighchartsReact
            highcharts={Highcharts}
            constructorType={'stockChart'}
            options={stockOptions}
            className="chart"
        />     
    )
}